export default {
  yesOrNo: [
    { name: "是", value: 1 },
    { name: "否", value: 0 }
  ],
  docTpCdTrans: [
    { value: "0", name: "订单" },
    { value: "1", name: "结算单" },
    { value: "2", name: "发票" },
    { value: "3", name: "付款承诺" },
    { value: "4", name: "其他" },
    { value: "5", name: "票据" },
    { value: "6", name: "发货通知" },
    { value: "10", name: "保单" },
    { value: "11", name: "对账单" },
    { value: "TCI", name: "交强险" },
    { value: "VCI", name: "商业车险" }
  ],
  docTpCdTransMin: [
    { value: "0", name: "订单" },
    { value: "1", name: "结算单" },
    { value: "2", name: "发票" },
    { value: "3", name: "付款承诺" },
    { value: "4", name: "其他" },
    { value: "5", name: "票据" }
  ],
  modifiedStatus: [
    { value: "0", name: "不可变更" },
    { value: "1", name: "可变更" },
    { value: "2", name: "已变更" },
    { value: "3", name: "待复核" }
  ],
  // financeStatus:[
  //     {value: '0', name: '待复核'},
  //     {value: '1', name: '复核已拒绝'},
  //     {value: '2', name: '待审批'},
  //     // {value: '3', name: '审批中'},
  //     {value: '4', name: '审批已拒绝'},
  //     {value: '5', name: '待放款'},
  //     {value: '6', name: '已放款'},
  //     {value: '7', name: '已逾期'},
  //     {value: '8', name: '已结清'}
  // ],
  financeStatus: [
    { value: "6", name: "待复核" },
    { value: "7", name: "复核已拒绝" },
    { value: "8", name: "待平台审核" },
    { value: "9", name: "待资方审批" },
    { value: "13", name: "平台审核已拒绝" },
    { value: "10", name: "资方审批已拒绝" },
    { value: "11", name: "待放款" },
    { value: "14", name: "放款中" },
    { value: "12", name: "已放款" }
  ],
  invType: [
    { name: "专用发票", value: "0" },
    { name: "电子专票", value: "1" },
    { name: "普通发票", value: "2" },
    { name: "电子普票", value: "3" },
    { name: "数电票", value: "4" }
  ],
  useOfFunds: [
    { value: "0", name: "支付货款" },
    { value: "1", name: "支付工资" },
    { value: "2", name: "其他" }
  ],
  // 银行前端显示对应
  bankList: {
    nongye: {
      name: "农业银行"
    },
    weishang: {
      name: "微商银行"
    },
    shanghai: {
      name: "上海银行"
    },
    beijing: {
      name: "北京银行"
    },
    pingan:{
      name: "平安银行"
    }
  },
  // 银行后、前端字典值转换
  bankListMap:{
    "abchina":"nongye",
    "weishang":"weishang",
    "shanghai":"shanghai",
    "beijing":"beijing",
    "pingan":"pingan",
    "zhongxin":"zhongxin"
  },
  // 应收单据使用状态
  useStatusList: [
    {
      name: "未匹配",
      value: "UNMATCHED"
    },
    {
      name: "未使用",
      value: "UNUSED"
    },
    {
      name: "已锁定",
      value: "LOCKED"
    },
    {
      name: "使用中",
      value: "INUSE"
    },
    {
      name: "已使用",
      value: "USED"
    }
  ],
  // 文件类型
  fileTpCd: [
    {
      name: "底层资产材料",
      value: "0",
      fileSubTpCd: [
        {
          name: "贸易双方主体材料",
          value: "0"
        },
        {
          name: "贸易合同",
          value: "1"
        },
        {
          name: "发票",
          value: "2"
        },
        {
          name: "其它",
          value: "3"
        }
      ]
    },
    {
      name: "重要凭证",
      value: "1",
      fileSubTpCd: [
        {
          name: "买方确认函",
          value: "0"
        },
        {
          name: "付款确认书",
          value: "1"
        },
        {
          name: "其它",
          value: "2"
        }
      ]
    },
    {
      name: "融资放款凭证",
      value: "2",
      fileSubTpCd: [
        {
          name: "回单",
          value: "0"
        },
        {
          name: "其它",
          value: "1"
        }
      ]
    },
    {
      name: "内部审批材料",
      value: "3",
      fileSubTpCd: [
        {
          name: "内部审批材料",
          value: "0"
        }
      ]
    },
    {
      name: "发票明细",
      value: "4"
    },
    {
      name: "其他",
      value: "5"
    },
    {
      name: "付款凭证",
      value: "6"
    }
  ],

  // 银行其他资料配置--没有接口临时的
  relatedFileContents:{
    "beijing":[
      {
        id:'A6_1',
        name:"最新一期财务报表",
        required:true
      },
      // {
      //   id:'A15_1',
      //   name:"授权委托书",
      //   required:true,
      //   template:{
      //     name:"《授权委托书》模板",
      //     url:"templat_07"
      //   }
      // },
      {
        id:'FZX5_1',
        name:"股东会决议及签字样本",
        required:true,
        template:{
          name:"《股东会决议及签字样本》模板",
          url:"templat_08"
        }
      },
      {
        id:'A13_1',
        name:"其他资料",
        required:false,

      }
    ]
  },
  // 线上签署协议
  fileListOnline:{
    "shanghai":[
      {
        id:1,
        name:"中国农业银行股份有限公司保理e融保理融资协议",
        required:true
      },
      {
        id:2,
        name:"中国农业银行股份有限公司保理e融委托扣款三方协议",
        required:true
      }
    ]
  },
  // 银行建档补充资料提示说明
  bankFilingRemark:{
    "beijing":["标注*项为必填项。上述资料格式需为PDF\图片（bmp,jpg,png），大小不可超过10MB。","请将上述资料的原件，在2周内邮寄至北京银行城市副中心分行国际新城支行。联系人：赵放；电话：18810785171；地址：北京市通州区梨园南街326号二层。"]
  },
  // 银行建档上传资料配置--没有接口临时的
  bankFilingFileList:{
    "beijing":[
      {
        id:1,
        name:"营业执照（正本）",
        required:true,
        remark:"扫描件需加盖公章"
      },
      {
        id:2,
        name:"营业执照（副本）",
        required:true,
        remark:"扫描件需加盖公章"
      },
      {
        id:3,
        name:"开户许可证",
        required:true,
        remark:"扫描件需加盖公章"
      },
      {
        id:4,
        name:"法人身份证",
        required:true,
        remark:"扫描件需加盖公章"
      },
      {
        id:5,
        name:"经办人身份证",
        required:true,
        remark:"扫描件需加盖公章"
      },
      {
        id:6,
        name:"《北京银行非自然人客户收益所有人信息采集表》",
        required:true,
        remark:"（法人本人签字、盖公章）（正反打印，或骑缝加盖公章）",
        template:{
          name:"模板下载",
          url:"templat_04"
        }
      },
      {
        id:7,
        name:"《公司CIF系统客户规模信息登记表》",
        required:true,
        remark:"经办人签字",
        template:{
          name:"模板下载",
          url:"templat_03"
        }
      },
      {
        id:8,
        name:"《人行征信授权书》",
        required:true,
        remark:"有权人签字、盖公章",
        template:{
          name:"模板下载",
          url:"templat_02"
        }
      },
      // {
      //   id:9,
      //   name:"与核心企业贸易背景合同及发票",
      //   required:false,
      //   remark:"扫描件需加盖公章"
      // },
      // {
      //   id:10,
      //   name:"企业近一年及近期财务报表",
      //   required:false,
      //   remark:"扫描件需加盖公章"
      // },
      {
        id:12,
        name:"出账25%以上的人员身份证或者公司营业执照",
        required:true,
        remark:"扫描件需加盖公章"
      },
      {
        id:11,
        name:"其他资料",
        required:false,
        remark:"扫描件需加盖公章"
      }
    ]
  },
};



// WEBPACK FOOTER //
// ./src/common/constant-dict.js